module.exports = __webpack_public_path__ + "images/help/icon-twr53-435bf96ab2e3bd11786e7a4ab068c03e.png";